export default __webpack_public_path__ + "static/media/RT_1.8ee44f56.png";